import { inject, Injectable } from '@angular/core';

import { ExploreLinkCreatorService } from '../../../services/explore-link-creator.service';
import { RouterLinkCreatorService } from '../../../services/router-link-creator.service';
import { MainNavSingleItemData } from '../model/main-nav.model';

@Injectable({
  providedIn: 'root'
})
export class MainNavItemsService {
  readonly #routerLinkCreatorService = inject(RouterLinkCreatorService);
  readonly #exploreLinkCreatorService = inject(ExploreLinkCreatorService);

  get businessPageRootLink() {
    return this.#exploreLinkCreatorService.createBusinessPageLink();
  }

  get plansLink() {
    return this.#routerLinkCreatorService.createStaticPageLink('purchase');
  }

  get pricingLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('pricing');
  }

  get ourPurposeLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('purpose');
  }

  get aboutUsLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('about-us');
  }

  get becomePartnerLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('become-a-partner');
  }

  get advisoryBoardLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('advisory-board');
  }

  get contactLink() {
    return this.#exploreLinkCreatorService.createStaticPageLink('contact');
  }

  get plansItem(): MainNavSingleItemData {
    return {
      link: this.plansLink,
      title: 'footer.pricing',
      dataCy: 'main-nav-plans'
    };
  }

  get pricingExternal(): MainNavSingleItemData {
    return {
      link: this.pricingLink,
      title: 'footer.pricing',
      dataCy: 'main-nav-plans'
    };
  }

  get ourPurposeItem(): MainNavSingleItemData {
    return {
      link: this.ourPurposeLink,
      title: 'header.our-purpose'
    };
  }

  get aboutUsItem(): MainNavSingleItemData {
    return {
      link: this.aboutUsLink,
      title: 'header.the-team'
    };
  }

  get becomePartner(): MainNavSingleItemData {
    return {
      link: this.becomePartnerLink,
      title: 'general.become-partner'
    };
  }

  get advisoryBoardItem(): MainNavSingleItemData {
    return {
      link: this.advisoryBoardLink,
      title: 'header.advisory-board'
    };
  }

  get contactItem(): MainNavSingleItemData {
    return {
      link: this.contactLink,
      title: 'header.contact-us'
    };
  }

  get newsfeedItem(): MainNavSingleItemData {
    return {
      link: this.#routerLinkCreatorService.createNewsFeedLink(),
      title: 'header.newsfeed'
    };
  }

  get home(): MainNavSingleItemData {
    return {
      link: this.#routerLinkCreatorService.createDomainLangPrefix(),
      title: 'header.home'
    };
  }

  get topIndustriesItem(): MainNavSingleItemData {
    return {
      link: this.#routerLinkCreatorService.createRanksCategoryLink('industry-groups'),
      title: 'ranks.industry-groups.favourite-categories'
    };
  }

  get ranksOverviewItem(): MainNavSingleItemData {
    return {
      link: this.#routerLinkCreatorService.createRanksLink('overview'),
      title: 'header.top-companies'
    };
  }

  get businessRootItem(): MainNavSingleItemData {
    return {
      link: this.businessPageRootLink,
      title: 'header.business-page'
    };
  }

  get mediaItem(): MainNavSingleItemData {
    return {
      link: this.#routerLinkCreatorService.createMediaLink(),
      title: 'header.media'
    };
  }
}
